<app-dialog-base [Title]='"Set icons"|translate' [dialogId]="dialogId" (onClose)="close()" (onSubmit)="submit()" [width]="'470px'" [height]="'330px'" [isSubmitDisabled]="isLoading" [isLoading]="isLoading">

  <div class="table">
    <div class="blockheader">{{'Personalization'|translate}}</div>
    <div class="datablock">
      <div class="inputgroup" style="z-index: 13;">
        <app-icon-selector [icons]="Icons" [selectedIcon]="model.Icon.Id" (onIconSelected)="onIconChange($event)"></app-icon-selector>
      </div>
    </div>
  </div>

</app-dialog-base>
